import { Head, usePage } from "@inertiajs/react";
import React from "react";

interface InertiaMetaTag {
  tagName: React.ElementType;
  innerContent?: unknown;
  headKey: string;
  httpEquiv?: string;
  [key: string]: unknown;
}

export default function MetaTags() {
  const { _inertia_meta: meta } = usePage<{ _inertia_meta: InertiaMetaTag[] }>().props;

  return (
    <Head>
      {Array.isArray(meta) &&
        meta.map((metaTag) => {
          const { tagName, innerContent, headKey, httpEquiv, ...attrs } = metaTag;
          const normalizedTagName = typeof tagName === "string" ? tagName.toLowerCase() : tagName;

          if (
            normalizedTagName === "title" ||
            headKey === "title" ||
            headKey === "meta-name-title" ||
            attrs.name === "title"
          ) {
            return null;
          }

          let stringifiedInnerContent;
          if (innerContent != null) {
            stringifiedInnerContent = typeof innerContent === "string" ? innerContent : JSON.stringify(innerContent);
          }

          return React.createElement(tagName, {
            key: headKey,
            "head-key": headKey,
            ...(httpEquiv ? { "http-equiv": httpEquiv } : {}),
            ...attrs,
            ...(stringifiedInnerContent ? { dangerouslySetInnerHTML: { __html: stringifiedInnerContent } } : {}),
          });
        })}
    </Head>
  );
}
